import { render, staticRenderFns } from "./KloosterViewer.vue?vue&type=template&id=22ac3477"
import script from "./KloosterViewer.vue?vue&type=script&lang=js"
export * from "./KloosterViewer.vue?vue&type=script&lang=js"
import style0 from "./KloosterViewer.vue?vue&type=style&index=0&id=22ac3477&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports